import { useEffect, useState } from 'react'
import './Header.scss'

import downarrow from './image/down-arrow.png'
import crossicon from './image/cross-icon.png'
import logo from "./image/logo.png"
import logo2 from "./image/logo2.png"
import LogoutIcon from '@mui/icons-material/Logout';
import hamburger from './image/hamburger.png'
import { motion, AnimatePresence } from 'framer-motion';
import { Link, useLocation, useNavigate } from 'react-router-dom'
import HoverImage from './hoverImage'
import { hoverImages, navLinks } from './HeaderSecDatas'
import { ParagraphComp } from '../ParagraphComp/ParagraphComp'
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import ButtonComp from '../ButtonComp/ButtonComp'
import { npoCount } from '../../Store/auth/header'
import { useQuery } from '@tanstack/react-query'
import Loading from '../../Components/Loader/Loading'


const HeaderSec = () => {

  const location = useLocation();
  const isSecRoute = location.pathname === '/';

  const [navOpen, setNavOpen] = useState(false)
  const [bottomNavOpen, setBottomNavOpen] = useState(false)
  const [hamburgertoggle, setHamburgertoggle] = useState(false)
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const email = localStorage.getItem("email")
  const dataUserAccessToken = localStorage.getItem("dataUserAccessToken")
  const [TempSearch, setTempSearch] = useState()
  const onChange = (e) => {
    const { value } = e?.target;
    setTempSearch(value);
  }

  const token = localStorage.getItem('NpoToken')

  const navigate = useNavigate()
  const CallSearch = () => {
    const query = encodeURIComponent(TempSearch.trim());
    navigate(`/search?header=${query}`, { replace: true }); // Update URL without refreshing
  };
  const searchParams = new URLSearchParams(window.location.search);
  const header = searchParams.get('header');

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      CallSearch();
    }
  }

  useEffect(() => {
    setTempSearch(header || ''); // Set the state to the query or an empty string
  }, [header]);


  const clearSec = () => {
    localStorage.clear()
  }
  const { isLoading: countLoading, data: getCount } = useQuery({
    queryKey: ['npoCount'],
    queryFn: () => npoCount(),
    refetchOnWindowFocus: false,
    cacheTime: 1000 * 60 * 5,
    staleTime: 0, // Setting staleTime to 0 will make sure data is marked as stale immediately
  });
  const navigateAdvancedSearch = () => {
    // e.preventDefault()
    navigate('/search')
  }

  const clearSearch = () => {
    setTempSearch('')
    if (header) {
      navigate(`/search`, { replace: true }); // Update URL without refreshing
    }
  }

  const handleScroll = (id) => {
    // If already on home page
    if (window.location.pathname === '/') {
      scrollToElement(id);
      return;
    }

    // Navigate to home page with scroll target in state
    navigate('/', {
      state: { scrollTo: id },
      replace: true  // Prevent adding to history
    });
  };

  // Scroll helper function
  const scrollToElement = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });

      // Clean URL if hash was added
      if (window.location.hash) {
        window.history.replaceState(null, '', window.location.pathname);
      }
    }
  };

  // In your home page component
  useEffect(() => {
    if (location.state?.scrollTo) {
      scrollToElement(location.state.scrollTo);
      // Clear state to prevent re-scrolling on refresh
      navigate('.', { replace: true, state: {} });
    }
  }, [location]);

  // if (countLoading) return <><Loading /></>

  return (
    <div className='newnavbar no-print'>
      <div className="inner">

        {/* first section  */}

        <div className="firstsec">
          <div onClick={() => { navigate('/') }} className={`left ${!isSecRoute ? 'cursor-pointer' : ''}`}>
            <div className='flex gap-1 items-start'>
              <div className='bg-[#80808067] h-[30px] max-lg:hidden flex items-center justify-center rounded-full px-[10px] py-[10px] '>
                <ParagraphComp className='text-sm  text-[#004878] font-bold text-center' >
                  BETA
                </ParagraphComp>
              </div>
              <img src={logo} alt="logo" />
            </div>
            <p>.</p>
          </div>
          <div className="right">
            <div className='flex items-center gap-1'>
              <div className="glance p-[10px] rounded-t-xl bg-[#00487812] flex items-end gap-[30px] justify-start font-[700] w-fit" >
                <div className=''>
                  <a onClick={(e) => { navigateAdvancedSearch(e) }} href="/search"><p className='text-gray-500 italic font-thin underline text-xl' >Advanced Search</p></a>
                </div>
              </div>
              <div className="glance">
                <div>
                  <div onClick={() => setNavOpen(!navOpen)} className='flex text-[#C00000] gap-[10px] text-xl items-start'>
                    <p className='font-bold'>GuideStar India at a glance</p>
                    <img src={!navOpen ? downarrow : crossicon} alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div className='flex items-end flex-col md:w-[100%]  p-[10px] bg-[#00487812] rounded-tr-lg'>
              <div className="inputlayout ">
                <div className="input">
                  <input onKeyDown={handleKeyDown} className='' value={TempSearch} onChange={onChange} type="text" placeholder='Enter organisation name or keyword or GSN/PAN/Darpan ID/FCRA Number' />
                  {TempSearch ? (
                    <div
                      className="rounded-full px-[15px] duration-[2s] delay-75 ease-in cursor-pointer bg-[#ED1C24]"
                      onClick={() => {
                        setTempSearch('');
                        clearSearch()
                      }}
                    >
                      <CloseIcon className="text-white" />
                    </div>
                  ) : (
                    <SearchIcon id="iconSize40px" className="text-gray-500 h-[30px] w-[30px] text-[40px]" />
                  )}
                </div>
                <ButtonComp
                  onClick={CallSearch}
                  className="rounded-[5px] bg-[#004878] max-md:mt-[10px] max-md:rounded-l-[5px] h-[40px] px-[20px] border-l-transparent rounded-l-none border-2 border-[#004878] text-white"
                  text="Search"
                />
              </div>
              <ParagraphComp text='NPO/ NGO/ Charity Check' className='leading-tight mt-[10px] text-[14px] text-[#004878] font-bold' />
            </div>


          </div>

        </div>

        {/* second section  */}

        <AnimatePresence>
          {navOpen && (
            <motion.div
              className="secondsec"
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: 'auto', opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 1 }}
            >
              <div className="innersec">
                <div className="one">
                  <img src={logo2} alt="" />
                </div>
                <div className="two">
                  <ul>
                    <li><a href="" >Theory of Change and Impact</a></li>
                    <li><a href="" >People, Partners and Supporters</a></li>
                  </ul>
                </div>
                <div className="two">
                  <ul>
                    <li><a href="">How to Discover/ Support Credible NPOs</a></li>
                    <li><a href="">How we enhance Credibility of NPOs</a></li>
                  </ul>
                </div>
                <div className="two">
                  <ul>
                    <li><a href="">Research Reports & Insights</a></li>
                    <li><Link to="/statutory-information">Statutory Information and FCRA Compliance</Link></li>
                  </ul>
                </div>
                <div className="three">
                  <p>Contact Us</p>
                  <div className="icon">
                    {hoverImages.slice(0, 3).map((image, index) => (
                      <HoverImage
                        key={index}
                        defaultSrc={image.defaultSrc}
                        hoverSrc={image.hoverSrc}
                        alt={image.alt}
                        link={image.link}
                      />
                    ))}
                  </div>
                  <div className="icon">
                    {hoverImages.slice(3).map((image, index) => (
                      <HoverImage
                        key={index + 3}
                        defaultSrc={image.defaultSrc}
                        hoverSrc={image.hoverSrc}
                        alt={image.alt}
                        link={image.link}
                      />
                    ))}
                  </div>

                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>



        {/* third section  */}

        <div className="thirdsec" onMouseEnter={() => {
          setHoveredIndex(null)
          setBottomNavOpen(false)
        }}>
          <div className="innersec">
            <div className="nposcount">
              <h4>{getCount?.message?.count?.toLocaleString() || '-'}</h4>
              <h5>Live NPOs</h5>
            </div>
            <h5>India&apos;s most exhaustive information repository of Not-for-Profit Organisations (NPOs/ NGOs)</h5>
          </div>
        </div>


        {/* fourth section  */}

        <div className="fourthsec">
          <div className="mobile">
            <div className="mobilelogo">
              <div className='flex gap-1 items-start'>
                <div className='bg-[#80808067] h-[30px] max-2xl:hidden max-lg:block  flex items-center justify-center rounded-full px-[10px] py-[10px] '>
                  <ParagraphComp className='text-sm text-[#004878] font-bold text-center' >
                    BETA
                  </ParagraphComp>
                </div>
                <img src={logo} alt="" />
              </div>
            </div>
            <div className="hamburger" onClick={() => setHamburgertoggle(!hamburgertoggle)}>
              <img src={hamburger} alt="" />
            </div>
          </div>

          <ul>
            {navLinks.map((link, index) => (
              <li
                key={index}
                onMouseEnter={() => {
                  setHoveredIndex(index)
                  link.text === 'Home' ? setBottomNavOpen(true) : setBottomNavOpen(false)
                }}
                onClick={() => {
                  link.text === 'About Us' && setNavOpen(!navOpen)
                }}
                // onMouseLeave={() => setHoveredIndex(null)}
                style={{ position: 'relative' }}
              >
                {link.type === 'link' ? (
                  <>
                    <Link
                      to={link.to}
                      state={link.text === 'Update your NPO Profile' ? { isNPO: true } : undefined}
                      className='flex'
                    >
                      {link.text}
                      {(link.text === 'Home') ? <img src={downarrow} alt="" className='h-4 w-auto' /> : <></>}
                    </Link>
                  </>
                ) : link.type === 'anchor' ? (
                  <>
                    <h6 onClick={() => { handleScroll(link.to) }}>{link.text}</h6>
                    {link.sublinks && hoveredIndex === index && (
                      <motion.ul
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -10 }}
                        transition={{ duration: 0.3 }}
                        style={{
                          position: 'absolute',
                          left: 0,
                          top: '100%',
                          background: '#fff',
                          padding: '10px',
                          listStyle: 'none',
                          border: '1px solid #ddd',
                          zIndex: 1000
                        }}
                      >
                        {link.sublinks.map((sublink, subIndex) => (
                          <li key={subIndex}>
                            <Link onClick={() => { handleScroll(sublink.to) }}>{sublink.text} </Link>

                          </li>
                        ))}
                      </motion.ul>
                    )}
                  </>
                ) : link.type === 'text' ? (
                  <>
                    <h6 >{link.text}</h6>

                  </>
                ) : link.type === 'button' ? (

                  (token && link.text === 'Sign In / Create Account') || link.text === 'Profile Page' ?
                    <Link to={'/loginDataUser'}>
                      <button onClick={() => { clearSec() }} >
                        Logout
                        &nbsp;
                        <LogoutIcon className='text-white' />
                      </button>
                    </Link>
                    :
                    < Link to={link.to}>
                      <button>
                        {link.text}
                      </button>
                    </Link>
                ) : null}
              </li>
            ))}
          </ul>

          <motion.div
            className='mobilemenu'
            initial={{ opacity: 0, height: 0 }}
            animate={hamburgertoggle ? { opacity: 1, height: 'auto' } : { opacity: 0, height: 0 }}
            transition={{ duration: 0.5 }}
          >
            <ul>
              <li>
                <Link to='/' className='flex items-center'>
                  Home
                  <img src={downarrow} alt="" />
                </Link>
              </li>
              <li><a href="/search">Discover/ Support NPOs</a></li>
              <li><a href="">CERTIFIED NPOs LIST</a></li>
              <li><a href="">Update your NPO Profile</a></li>
              <li><a href="">help</a></li>
              <li><a href="">Media</a></li>
              {token ?
                <Link to="/loginDataUser">
                  <button onClick={() => { clearSec() }} >
                    Logout
                    &nbsp;
                    <LogoutIcon className='text-white' />
                  </button>
                </Link>
                :
                <Link to="/loginDataUser">
                  <button>
                    {(email || dataUserAccessToken) ? "Profile" : "Sign In / Create Account"}
                  </button>
                </Link>
              }

            </ul>
          </motion.div>

        </div>
        <AnimatePresence>
          {bottomNavOpen && (
            <motion.div
              className="fifthsec"
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: 'auto', opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 1.3 }}
            >
              <ul className="innersec">
                {navLinks[hoveredIndex]?.subLinks?.map((sublink, subIndex) => (
                  <li key={subIndex} className='sublink-item'>
                    <h6 onClick={() => { handleScroll(sublink.to) }}>{sublink.text}</h6>
                  </li>
                ))}
              </ul>
            </motion.div>
          )}
        </AnimatePresence>
        <div className='h-[2px] w-screen' onMouseEnter={() => {
          setHoveredIndex(null)
          setBottomNavOpen(false)
        }}></div>
      </div>
    </div >
  )
}

export default HeaderSec